import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";
import type { QueryType } from "@/common/types/common";

import type { PlanPayloadType } from "@/common/types/plan/plan";

export async function planList(query?: QueryType) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`plan/list${queryString}`);
}

export async function planGet(plan_id: string) {
	return await clientAxios.get(`plan/${plan_id}/show`);
}

export async function planCreate(payload: PlanPayloadType) {
	return await clientAxios.post(`plan/create`, payload);
}

export async function planUpdate(plan_id: string, payload: PlanPayloadType) {
	return await clientAxios.put(`plan/${plan_id}/update`, payload);
}

export async function planPatch(
	plan_id: string,
	payload: Partial<PlanPayloadType>,
) {
	return await clientAxios.patch(`plan/${plan_id}/patch`, { payload });
}

export async function planDelete(plan_id: string) {
	return await clientAxios.del(`plan/${plan_id}/delete`);
}
